/**
 * How to name a bank account in copy addressed to its owner.
 *
 * `accountNumberMask` is absent on some accounts — every manually-entered one on
 * the integration payer, for instance — and interpolating it unguarded produced
 * "your account ending in •••" with no digits. Falls back to the account's own
 * name, then to a generic phrase, so the sentence always reads.
 */
export const selectorExternalBankAccountLabel = (account: {
  accountNumberMask?: string;
  accountName?: string;
  nickname?: string;
}): string => {
  if (account.accountNumberMask) {
    return `your account ending in •••${account.accountNumberMask}`;
  }
  return account.nickname || account.accountName || "your bank account";
};
